// This component is generated by svgr. DO NOT EDIT.
import { SVGProps } from 'react'
type Props = {
  size?: 'sm' | 'md' | 'lg' | (string & {}),
} & Omit<SVGProps<SVGSVGElement>, 'width' | 'height' | 'color'>
const SvgFiletypeZip = ({ size = 'md', ...props }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={
      size === 'sm'
        ? '8px'
        : size === 'md'
        ? '16px'
        : size === 'lg'
        ? '24px'
        : size
    }
    height={
      size === 'sm'
        ? '8px'
        : size === 'md'
        ? '16px'
        : size === 'lg'
        ? '24px'
        : size
    }
    fill="none"
    viewBox="0 0 158 206"
    {...props}
  >
    <path
      fill="#999"
      d="M0 4a4 4 0 0 1 4-4h95.807c2.366 0 4.637.932 6.322 2.595l33.193 32.762A9 9 0 0 1 142 41.762V183a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4z"
    />
    <path
      fill="#fff"
      d="M4 6a2 2 0 0 1 2-2h92a2 2 0 0 1 2 2v26.5c0 5.523 4.477 10 10 10h26a2 2 0 0 1 2 2V181a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z"
    />
    <path
      fill="#999"
      fillRule="evenodd"
      d="M67 3h-4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m0 16h-4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2m-4 48h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2m4 16h-4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2m4-56h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2m4-16h-4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2m-4 64h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2m-4-40h-4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2m4 8h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2m-5 8h-4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2m5 8h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2M86.552 120c0 5.523-4.632 12-10.345 12H63.793c-5.713 0-10.345-6.477-10.345-12l4.138-20c0-3.314 2.78-6 6.207-6h12.414c3.428 0 6.207 2.686 6.207 6zm-10.345 8c3.428 0 6.207-4.686 6.207-8l-4.138-20c0-1.105-.926-2-2.07-2H63.794c-1.142 0-2.069.895-2.069 2l-4.138 20c0 3.314 2.78 8 6.207 8z"
      clipRule="evenodd"
    />
    <path
      fill="#999"
      d="M65.082 113.507a3 3 0 0 1 2.96-2.507h2.916a3 3 0 0 1 2.96 2.507l1 6a3 3 0 0 1-2.96 3.493h-4.917a3 3 0 0 1-2.959-3.493zM22 166a4 4 0 0 1 4-4h128a4 4 0 0 1 4 4v36a4 4 0 0 1-4 4H26a4 4 0 0 1-4-4z"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="m101.584 172.764-.239-.011.032.237c.166 1.25.222 2.249.222 3.586v15.148c0 1.506-.056 2.475-.222 3.582l-.034.23h4.61l-.036-.231c-.166-1.05-.222-2.102-.222-3.609v-4.476h5.148c2.72 0 4.683-.653 6.105-2.075l.004-.003c1.273-1.331 1.931-3.12 1.931-5.29 0-2.052-.599-3.79-1.795-4.958-1.395-1.394-3.358-2.046-6.105-2.046h-5.852a67 67 0 0 1-3.547-.084m4.111 10.836v-7.132h5.148c1.458 0 2.315.302 2.905.943l.002.003c.571.597.869 1.465.869 2.55 0 1.194-.339 2.095-.961 2.698-.624.604-1.561.938-2.815.938zM96.182 172.848H91.46l.034.23c.166 1.107.222 1.853.222 3.582v15.064c0 1.647-.056 2.531-.221 3.581l-.037.231h4.724l-.036-.231c-.166-1.05-.222-1.934-.222-3.581V176.66c0-1.674.056-2.531.222-3.581zM70.068 172.653l-.22-.023v4.146l.226-.03c.827-.11 2.302-.194 3.921-.194h5.936c.367 0 1.012-.016 1.546-.037l-.063.075-.068.079-.014.016q-.3.35-.798.938l-9.355 11.765-.002.001c-.979 1.259-1.67 2.059-2.244 2.579l-.066.059v3.604l.21-.011a60 60 0 0 1 3.63-.084h10.416c2.04 0 2.926.056 4.035.195l.225.028v-4.148l-.224.026c-1.165.139-2.416.195-4.036.195h-7c-.45 0-.906.007-1.312.014l-.172.003-.385.007a18 18 0 0 0 1.009-1.204l.094-.121 9.127-11.535c.952-1.204 1.7-2.09 2.333-2.695l.062-.059v-3.489l-.21.011a78 78 0 0 1-3.63.084h-9.044a35 35 0 0 1-3.927-.195M65.024 191.048h-4.488v4.488h4.488z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgFiletypeZip
